import { EntityLink } from '@/shared/ui/entity-link'

interface ReservationLinkProps {
  id: string
  label?: string
  className?: string
}

export function ReservationLink({ id, label, className }: ReservationLinkProps) {
  return (
    <EntityLink
      to="/capacity/$reservationId"
      params={{ reservationId: id }}
      icon="bolt"
      mono
      className={className}
    >
      {label ?? id}
    </EntityLink>
  )
}
